import { render } from "./collegesSetupSign.vue?vue&type=template&id=098d6d7c&scoped=true&ts=true"
import script from "./collegesSetupSign.vue?vue&type=script&lang=ts"
export * from "./collegesSetupSign.vue?vue&type=script&lang=ts"

import "./collegesSetupSign.vue?vue&type=style&index=0&id=098d6d7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-098d6d7c"]])

export default __exports__